<template>
  <div :class="fileUploaderContainerClass">
    <div class="title">
      {{
        type && required ? type + "*" : type || intl[$store.state.lang]["title"]
      }}
    </div>
    <div v-if="showInfo" class="update-info-container">
      <div>{{ intl[$store.state.lang]["file-formats"] }}</div>
      <div>{{ intl[$store.state.lang]["max-dim"] }}</div>
      <div>{{ intl[$store.state.lang]["max-file-number"] + max_files_number }}</div>
      <div>{{ intl[$store.state.lang]["title"] }}</div>
    </div>
    <div :id="'drag-and-drop-' + id" class="drag-and-drop">
      <file-pond
        name="test"
        ref="pond"
        :label-idle="intl[$store.state.lang]['drop-message']"
        allow-multiple="true"
        labelFileTypeNotAllowed="ATTENZIONE: Questo file non verrà inviato"
        fileValidateTypeLabelExpectedTypes="Il formato non rientra tra quelli accettati."
        maxFileSize="1MB"
        :allowFileSizeValidation="true"
        labelMaxFileSizeExceeded="ATTENZIONE: file NON COERENTE"
        labelMaxFileSize="La dimensione massima è di 1MB"
        :max-files="max_files_number"
        v-on:addfile="onAddFileCallback"
        v-on:removefile="onRemoveFileCallback"
        v-on:updatefiles="onUpdateFiles"
        imagePreviewHeight="100px"
        accepted-file-types="image/jpeg, image/png, application/pdf, 	application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        v-bind:files="selectedFiles"
      />
      <div :id="'attachment-error-message-' + id" class="attachment-error-message d-none">
        {{intl[$store.state.lang][errorMessageKey]}}<i class="bi bi-exclamation-circle"></i>
      </div>
      <div :id="'attachment-ok-message-'+this.id" class="attachment-ok-message d-none">
        Ok. <i class="bi bi-check-lg"></i>
      </div>
      <button
        v-if="useFileUploaderButton"
        class="btn btn-success"
        @click="onUpload"
      >
        {{ intl[$store.state.lang]["upload"] }}
      </button>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import { apiUrls } from "../../api/apiUrls";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateSize
);
export default {
    name: "fileUploader",
    mounted() {},
    components: {
      FilePond
    },
    props: {
        id: {
            type: Number,
            default: null
        },
        required: {
            type: Boolean,
            default: false
        },
        showInfo: {
            type: Boolean,
            default: true
        },
        showError: {
            type: Boolean,
            default: false
        },
        folderName: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: null
        },
        ticketId: {
            type: Number,
            default: null
        },
        max_files_number: {
          type: Number,
          default: 5
        },
        extra_request_id:{
            type: Number,
            default: 0
        },
        onAddFileCallback:{
            type:Function,
            default: (error, file) => {console.log("File uploaded: ",file)}
        },
        onRemoveFileCallback:{
            type:Function,
            default: (error, file) => {console.log("File removed: ",file)}
        },
        onUpdateFilesCallback:{
            type:Function,
            default: (files) => {console.log("Files: ",files)}
        },
        useFileUploaderButton: {
            type: Boolean,
            default: true
        },
        setPaginaLoaderCallback: {
            type: Function,
            default: (value) => {
              //console.log("FILE UPLOADER LOADER: ",value)
              return;
            },
        },

    },
    created() {

    },


    data: function () {
        return {
            fileUploaderLoader: false,
            intl: intl,
            selectedFiles: [],
            filePondFiles: [],
            almenoUnFileNonCoerente: false

        };
    },
    methods: {
      //SE E' PRESENTE UN FILE NON COERENTE E SE E' STATO GIA' PREMUTO SUL SUBMIT(ESISTE LA CLASSE ALL-OK) MOSTRO L'ERRORE
      //SE NON CI SONO FILE COERENTI MA NON E' PRESENTE NESSUN FILE CARICATO CORRETTAMENTE E' STATO GIA' PREMUTO SUL SUBMIT(ESISTE LA CLASSE ALL-OK) MOSTRO L'ERRORE
      //ALTRIMENTI SE CI SONO FILE COERENTI E E' PRESENTE LA CLASSE DI ERRORE MOSTRO QUELLA OK
      handleErrorsFileObbligatorio(filesCaricatiCorrettamente) {
        if(this.almenoUnFileNonCoerente && document.getElementById("drag-and-drop-"+this.id).classList.contains("all-ok")){
              this.showErrorMessage()
            }
            else if(!this.almenoUnFileNonCoerente  && filesCaricatiCorrettamente.length === 0 && document.getElementById("drag-and-drop-"+this.id).classList.contains("all-ok")){
              this.showErrorMessage()
            }else if(!this.almenoUnFileNonCoerente && filesCaricatiCorrettamente.length > 0 && document.getElementById("drag-and-drop-"+this.id).classList.contains("error-message")){
              this.showGreenBorder()
            }
      },

      //SE E' PRESENTE UN FILE NON COERENTE E SE E' STATO GIA' PREMUTO SUL SUBMIT(ESISTE LA CLASSE ALL-OK) MOSTRO L'ERRORE
      //ALTRIMENTI SE E' STATO GIA' PREMUTA LA SUBMIT E C'E' UNA CLASSE DI ERRORE MOSTRO QUELLA OK
      handleErrorsFileOpzionale(filesCaricatiCorrettamente) {
        if(this.almenoUnFileNonCoerente && (document.getElementById("drag-and-drop-"+this.id).classList.contains("all-ok") || document.getElementById("drag-and-drop-"+this.id).classList.contains("error-message")) ){
              this.showErrorMessage()
        }
        else if(document.getElementById("drag-and-drop-"+this.id).classList.contains("error-message")) {
          this.showGreenBorder()
        }
      },
      onUpdateFiles(files){
          this.almenoUnFileNonCoerente = false

          let filesCaricatiCorrettamente = []
          files.map((file) => {
            if(file.status === 2){
              filesCaricatiCorrettamente.push(file)
            }else{
              this.almenoUnFileNonCoerente = true
            }
          })
          if(this.required){
            this.handleErrorsFileObbligatorio(filesCaricatiCorrettamente)
          }else{
            this.handleErrorsFileOpzionale(filesCaricatiCorrettamente)
          }

          this.filePondFiles = filesCaricatiCorrettamente
          this.onUpdateFilesCallback(filesCaricatiCorrettamente)
        },


    showErrorMessage(){
        document.getElementById("drag-and-drop-"+this.id).classList.remove("all-ok");
        document.getElementById("attachment-error-message-"+this.id).classList.remove("d-none");
        if (!document.getElementById("drag-and-drop-"+this.id).classList.contains("error-message")) {
            document.getElementById("drag-and-drop-"+this.id).classList.add("error-message");
        }
        if (!document.getElementById("attachment-ok-message-"+this.id).classList.contains("d-none")) {
            document.getElementById("attachment-ok-message-"+this.id).classList.add("d-none");
        }
      },
      removeErrorMessage(){
        document.getElementById("drag-and-drop-"+this.id).classList.remove("error-message");
        if (!document.getElementById("attachment-error-message-"+this.id).classList.contains("d-none")) {
             document.getElementById("attachment-error-message-"+this.id).classList.add("d-none");
        }
        
         
      },
      showGreenBorder(){
        this.removeErrorMessage();
        if (!document.getElementById("drag-and-drop-"+this.id).classList.contains("all-ok")) {
            document.getElementById("drag-and-drop-"+this.id).classList.add("all-ok");
        }
        document.getElementById("attachment-ok-message-"+this.id).classList.remove("d-none");
        
        
      },

      




      onUpload: function(){
          const fd = new FormData();
          this.$refs.pond.getFiles().map((file) => {
              if(file.status === 2){
                fd.append("file[]",file.file)
              }

          })
         
          fd.append("type",this.type)
          fd.append("extra_request_id",this.extra_request_id)
          fd.append("id_ticket",this.ticketId)
          this.fileUploaderLoader = true
          axios
          .post(apiUrls["create_ticket_attachments"],fd)
          .then((response) => {
            this.fileUploaderLoader = false
          })
          .catch((error) => {
            this.fileUploaderLoader = false
          });


      }
    },
    watch: {
       fileUploaderLoader : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue){
                        if(this.type){
                            this.setPaginaLoaderCallback({["fileUploaderLoader-"+this.type]: newValue})
                        }else{
                            this.setPaginaLoaderCallback({fileUploaderLoader: newValue})
                        }

                    }
                },
                immediate: true,
        },


    },
    computed: {
      errorMessageKey: function(){
        if(this.almenoUnFileNonCoerente){
          return "attachment-error-remove"
        }else{
          return 'attachment-error'
        }
      },
        fileUploaderContainerClass: function () {
            if(this.showError){
                return "file-uploader-container error"
            }else{
                return "file-uploader-container"
            }
        },
    },
};
</script>
